module.exports = __webpack_public_path__ + "img/pg5-article-title2-inner.00431baf.png";